import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@interxfi/design-system/components/accordion/accordion';
import { CardSummaryGroupBody, type CardSummaryItem } from './card-summary-group';
import styles from './accordion-summary-group.module.scss';

export type AccordionCardSummaryGroupVariant = 'default' | 'onNeutral';

interface AccordionSummaryGroupProps {
  icon?: ReactNode;
  id?: string;
  isPending: boolean;
  items: CardSummaryItem[];
  title: string;
  pill?: ReactNode;
  variant?: AccordionCardSummaryGroupVariant;
}

export function AccordionSummaryGroup({ icon, id, isPending, items, pill, title, variant = 'default' }: AccordionSummaryGroupProps) {
  return (
    <AccordionItem className={clsx(styles.accordionSummaryGroup, styles[`variant-${variant}`])} value={id ?? title}>
      <AccordionTrigger icon={icon} pill={pill}>
        {title}
      </AccordionTrigger>

      <AccordionContent role="group">
        <CardSummaryGroupBody isPending={isPending} items={items} />
      </AccordionContent>
    </AccordionItem>
  );
}
